// src/lib/socket.ts
import { io, type Socket } from "socket.io-client";

let socket: Socket | null = null;

const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5001"
    : "https://node-boilerplate-pww8.onrender.com"

export const getSocket = (token: string): Socket => {
  if (!socket) {
    socket = io(BASE_URL, {
      auth: {
        token,
      },
      transports: ["websocket"],
      withCredentials: true,
    });

    socket.on("connect", () => {
      console.log("✅ Socket connected:", socket?.id);
    });

    socket.on("disconnect", (reason) => {
      console.log("❌ Socket disconnected:", reason);
    });
  }

  return socket;
};

export const disconnectSocketInstance = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
